export default __webpack_public_path__ + "3517aeaa34b2f8cd8eeff67af0daab33.ttf";